import {Filter} from 'pixi.js';

export class BackgroundFilter extends Filter
{

    constructor() {
        const vertex = `            
attribute vec2 aVertexPosition;
uniform mat3 projectionMatrix;
varying vec2 vTextureCoord;
uniform vec4 inputSize;
uniform vec4 outputFrame;
varying vec4 inputSize1;
varying vec4 outputFrame1;

        vec4 filterVertexPosition( void )
        {
            vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

            return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
        }

        vec2 filterTextureCoord( void )
        {
            return aVertexPosition * (outputFrame.zw * inputSize.zw);
        }

        void main(void)
        {
            inputSize1 = inputSize;
            outputFrame1 = outputFrame;
            gl_Position = filterVertexPosition();
            vTextureCoord = filterTextureCoord();
        }`;
        const fragment = `
varying vec2 vTextureCoord;
varying vec4 inputSize1;
varying vec4 outputFrame1;
uniform sampler2D uSampler;

void main(void)
{
    vec2 normalized = vTextureCoord * inputSize1.xy / outputFrame1.zw;
    vec4 color = texture2D(uSampler, vTextureCoord);
    color *= 1.0-normalized.y;
    gl_FragColor = color;
}
`;
        super(vertex, fragment, {
            dimensions: {type: 'v2', value: [320, 186]}
        });

    }

}
